import React, { useRef } from "react";
import { useMemo } from "react";
import MessageItem from "./MessageItem";
import InfiniteScroll from "react-infinite-scroll-component";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import EmojiPicker from "emoji-picker-react";
import {
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Divider,
  Badge,
} from "@mui/material";
import { upload_audio, upload_image } from "src/utils/fileUpload";
import PhotoSizeSelectActualIcon from "@mui/icons-material/PhotoSizeSelectActual";
import SendIcon from "@mui/icons-material/Send";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import { useState } from "react";
import ImageSelector from "src/components/ImageSelector";
import { useAppContext } from "src/hooks";
import { useEffect } from "react";
import { _editMessage, _seenMessages } from "src/DAL";
import { useSnackbar } from "notistack";
import moment from "moment";
import VoiceRecorder from "../../../components/VoiceRecorder";
import ReplyMessageContainer from "./ReplyMessage";
import {
  del_from_local_storage,
  get_from_localStorage,
  set_to_localStorage,
} from "src/utils";
import ChatSeenAvatar from "./ChatSeenAvatar";
import ChatList from "./ChatList";
import ChatEmojisPicker from "./ChatEmojisPicker";

function MessageContainer({
  messageCount,
  loadMoreMessages,
  currentChat,
  onLastMassageView,
  handleAddNewChat,
  chatFile,
  setChatFile,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    messageList,
    setIsUserSeeningMessage,
    isUserSeeningMessage,
    loadingMessageList,
    setChatData,
    setMessageList,
    generateUniqueIdForMessage,
    setCurrentChat,
    isOpenChatDialog,
    isMinimizeChat,
  } = useAppContext();
  const { socketEmit, dispatch_get_user_profile } = useAppContext();
  const [isEditingMessage, setIsEditingMessage] = useState(false);
  const [targetEditMessage, setTargetEditMessage] = useState();
  const [repliedMessage, setRepliedMessage] = useState();
  const textareaRef = useRef(null);
  const messageTextRef = useRef(null);
  const [selectedMessage, setSelectedMessage] = useState(true);
  ///////////////////////////////Send Message/////////////////////////////////////////////////////////

  const [chatAudio, setChatAudio] = useState();
  const [newMessageText, setNewMessageText] = useState("");
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [isShowRecordingElement, setIsShowRecordingElement] = useState(false);
  const [isDiscardRecording, setIsDiscardRecording] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [audioDurationInSecond, setAudioDurationInSecond] = useState(0);
  const [isReplyIconVisible, setIsReplyIconVisible] = useState(false);
  const [hoveredMessageId, setHoveredMessageId] = useState();
  const [replyMessage, setReplyMessage] = useState(null);
  const [isShowEmojis, setIsShowEmojis] = useState(false);

  const memoizedReplyMessage = useMemo(() => replyMessage, [replyMessage?._id]);

  async function updatingChatData() {
    const userId = dispatch_get_user_profile().userId;
    await setChatData((prevChatData) => {
      const updatedChatData = {
        ...prevChatData,
        member_user: prevChatData.member_user.map((user) => {
          if (user.user_id !== userId) {
            return {
              ...user,
              unread_messages_count: user.unread_messages_count + 1,
            };
          }
          return user;
        }),
      };
      return updatedChatData;
    });
  }

  const handleSendMessage = async (e) => {
    if (isSendingMessage || (newMessageText == "" && !chatFile && !chatAudio)) {
      return;
    }
    setIsShowEmojis(false);
    setIsSendingMessage(true);
    try {
      await updatingChatData();

      let chatImg = "";
      if (chatFile) {
        console.log(chatFile, "Img File");

        const imgUplaodResult = await upload_image(chatFile);
        chatImg = imgUplaodResult.path;
      }
      if (chatAudio) {
        console.log("chat audio File", chatAudio);
        console.log("chat audio Duration", audioDurationInSecond);
        const audioUploadResult = await upload_audio(
          chatAudio,
          audioDurationInSecond
        );

        chatImg = audioUploadResult.path;
      }

      let req_data = {
        text: newMessageText,
        image: chatImg,
        message_status: 0,
        chat_id: currentChat._id,
        receiver_id: currentChat.user.map((user) => {
          return user.user_id;
        }),
        reply_message_id: replyMessage?._id || null,
        temp_id: generateUniqueIdForMessage(),
        chat_type: currentChat.type,
        audio_duration: chatAudio ? audioDurationInSecond : "",
      };

      console.log(req_data, "Message Sending Data");
      let tempMessageData = {
        ...req_data,
        reply_message_detail: replyMessage,
        audio_duration: chatAudio ? audioDurationInSecond : "",
        createdAt: moment().toISOString(),
        message_exist: true,
        message_sender: dispatch_get_user_profile(),
        message_type: "general",
        sender_id: dispatch_get_user_profile().user_id,
        _id: "",
      };
      console.log("calling socket");
      socketEmit("sendMessage", {
        ...req_data,
        user_id: dispatch_get_user_profile().user_id,
      });
      // Emit unread count update immediately after sending message
      socketEmit("send_unread_count", {
        user_id: dispatch_get_user_profile().user_id,
      });
      // _seenMessages(currentChat._id);
      setChatFile();
      setNewMessageText("");
      setChatAudio();
      setAudioDurationInSecond(0);
      setReplyMessage(null);
      setTimeout(() => {
        setMessageList((prev) => [tempMessageData, ...prev]);
      }, 0);
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched while sending message");
    } finally {
      setIsSendingMessage(false);
    }
  };

  const handleSendEditMessage = async (e) => {
    e.preventDefault();
    setReplyMessage(null);
    setIsShowEmojis(false);
    if (isSendingMessage || (newMessageText == "" && !chatFile)) {
      return;
    }
    if (!targetEditMessage) {
      return;
    }
    setIsSendingMessage(true);

    const data = { text: newMessageText };
    const result = await _editMessage(data, targetEditMessage._id);
    if (result.code == 200) {
      socketEmit("editMessage", {
        message_id: targetEditMessage._id,
        user_id: targetEditMessage.sender_id,
        text: newMessageText,
      });
      setNewMessageText("");
      setIsEditingMessage(false);
      enqueueSnackbar("Message Edited successfully", { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setIsSendingMessage(false);
  };
  /////////////////////////Text area change////////////////////////////////////////////
  let shift_pressed = false;

  const handleAreaChange = (e) => {
    e.preventDefault();
    const { value } = e.target;

    if (shift_pressed) {
      setNewMessageText(value);
      return;
    }
    if (e.nativeEvent.inputType === "deleteContentBackward") {
      setNewMessageText(value);
      return;
    }
    if (e.nativeEvent.inputType === "deleteWordBackward") {
      setNewMessageText(value);
      return;
    }
    if (e.nativeEvent.inputType === "insertText") {
      setNewMessageText(value);
      return;
    }
    if (e.nativeEvent.inputType === "insertFromPaste") {
      setNewMessageText(value);
      return;
    }
    if (e.nativeEvent.data === null) {
      if (e.nativeEvent.inputType === "insertFromPaste") {
        return;
      }
      if (e.nativeEvent.inputType === "deleteWordBackward") {
        return;
      }
      !isEditingMessage && handleSendMessage(e);
      isEditingMessage && handleSendEditMessage(e);
      return;
    }
    setNewMessageText(value);
  };

  const handleAreaKeyUp = (e) => {
    const { key } = e;
    if (key == "Shift") {
      shift_pressed = false;
    }
  };
  const handleAreaKeyDown = (e) => {
    if (e.shiftKey) {
      shift_pressed = true;
    }
    if (e.key === "Backspace") {
      if (isEditingMessage && newMessageText == "") {
        setIsEditingMessage(false);
      }
    }
  };

  const formatMessageDate = (date) => {
    const messageDate = moment(date);
    if (messageDate.isSame(moment(), "day")) {
      return "Today";
    } else if (messageDate.isSame(moment().subtract(1, "day"), "day")) {
      return "Yesterday";
    } else {
      return messageDate.format("MMM DD");
    }
  };

  const handleClosePage = () => {
    onStopRecording();
    setNewMessageText("");
    setChatAudio();
    setChatFile();
    setAudioDurationInSecond(0);
    setReplyMessage(null);
  };

  useEffect(() => {
    return () => {
      if (!isOpenChatDialog) {
        handleClosePage();
      }
    };
  }, [currentChat]);

  const [extraHeight, setExtraHeight] = useState(0);

  useEffect(() => {
    messageTextRef.current = newMessageText;

    if (textareaRef.current) {
      // Reset height to calculate true scroll height
      textareaRef.current.style.height = "3rem";
      textareaRef.current.style.overflowY = "hidden";

      const scrollHeight = textareaRef.current.scrollHeight;
      const maxHeight = 110; // Approx 5 lines max height

      const targetHeight = Math.min(scrollHeight, maxHeight);

      if (scrollHeight > maxHeight) {
        textareaRef.current.style.height = maxHeight + "px";
        textareaRef.current.style.overflowY = "auto";
      } else {
        textareaRef.current.style.height = scrollHeight + "px";
      }
      // Calculate how much larger than baseline (approx 45-48px) it expanded
      setExtraHeight(targetHeight > 48 ? targetHeight - 48 : 0);
    }
  }, [newMessageText]);

  useEffect(() => {
    setTimeout(() => {
      if (currentChat) {
        let draft = get_from_localStorage(currentChat._id);
        if (draft) {
          setNewMessageText(draft);
          del_from_local_storage(currentChat._id);
        }
        setReplyMessage(null);
      }
    }, 200);

    return () => {
      if (messageTextRef.current) {
        set_to_localStorage(currentChat?._id, messageTextRef.current);
        setNewMessageText("");
      }
    };
  }, [currentChat, isOpenChatDialog, isMinimizeChat]);

  //////////////////////////TEXT AREA EVENT LISTENERS FOR IMAGE///////
  const handlePaste = (e) => {
    let file = e.clipboardData.files[0];
    if (file) {
      if (!file.type.includes("image")) return;
      setChatFile(file);
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    let file = e.dataTransfer.files[0];
    if (file) {
      if (!file.type.includes("image")) return;
      setChatFile(file);
    }
  };
  function checkDateSame(item1, item2) {
    const date1 = item1?.createdAt.slice(0, 10);
    const date2 = item2?.createdAt.slice(0, 10);
    return date1 == date2;
  }
  const onStopRecording = (audioBlob, audioDuration) => {
    if (isShowRecordingElement) {
      if (!isDiscardRecording) {
        console.log("Recording completed: ", audioBlob);
        console.log("Recording File Duration: ", audioDuration);
        setAudioDurationInSecond(audioDuration);
        setChatAudio(audioBlob);
      } else {
        setIsDiscardRecording(false);
        console.log("Recording Discarded ... ");
      }
    }
    setIsShowRecordingElement(false);
  };

  function handleDoubleClick(message) {
    return () => {
      if (message.message_type == "general") {
        setReplyMessage(message);
        textareaRef.current.focus();
        console.log("Message selected: ", message);
      }
    };
  }

  useEffect(() => {
    if (chatAudio) {
      handleSendMessage();
      // console.log("called by chat messages", chatAudio);
    }
  }, [chatAudio]);

  useEffect(() => {
    if (isEditingMessage) {
      textareaRef.current.focus();
    }
  }, [isEditingMessage]);

  const [isEmptyMessageInView, setIsEmptyMessageInView] = useState(true);
  const scrollContainerRef = useRef(null);
  const eleRef = useRef(null);

  const handleSeenMessages = async () => {
    if (!currentChat) return;

    let res = await _seenMessages(currentChat._id);
    if (res.code === 200) {
      let receivers = currentChat.member_user;
      let receiverIds = receivers.map((member) => member.user_id);

      console.log("Calling seen message socket event");
      socketEmit("on_message_read", {
        chat_id: currentChat._id,
        receivers_id: receiverIds,
      });
    }
  };

  const checkInView = () => {
    if (!eleRef.current) return;

    const rect = eleRef.current.getBoundingClientRect();
    const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
    setIsEmptyMessageInView(isInView);
  };

  useEffect(() => {
    setTimeout(() => {
      checkInView();
    }, 100);
  }, [currentChat]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => checkInView();

    container.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [scrollContainerRef.current]);

  useEffect(() => {
    const seenIfNeeded = async () => {
      if (isEmptyMessageInView && currentChat?.unread_count > 0) {
        onLastMassageView();
        await handleSeenMessages();
      }
    };
    seenIfNeeded();
    // console.log("Message List Length has been changed", messageList.length);
  }, [isEmptyMessageInView, isOpenChatDialog, messageList.length, currentChat]);

  useEffect(() => {
    if (isUserSeeningMessage) {
      handleSeenMessages();
      setIsUserSeeningMessage(false);
    }
  }, [isUserSeeningMessage]);

  ////////////////////////////////////////////////////////////////////
  return (
    <div className="chat-messages-parent">
      <div
        className={`messages-container 
        ${replyMessage ? "messages-container-margin" : ""} 
        ${chatFile ? "messages-container-file" : ""}
        ${replyMessage && chatFile ? "messages-container-both" : ""}`}
      >
        {!isEmptyMessageInView && (
          <div
            className="chat-unread-count-container"
            onClick={() => {
              const targetElement =
                document.getElementById("last-empty-message");
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            <IconButton>
              <ArrowDownwardIcon className="" />
            </IconButton>
            {currentChat?.unread_count > 0 && (
              <Badge
                badgeContent={currentChat?.unread_count}
                max={99}
                sx={{
                  marginTop: "5px",
                  // width: "20px",
                  height: "20px",
                  "& .MuiBadge-badge": {
                    backgroundColor: "black",
                    color: "white",
                    fontSize: "10px",
                    height: "20px",
                    minWidth: "20px",
                    padding: "2px",
                  },
                }}
              ></Badge>
            )}
          </div>
        )}
        {!loadingMessageList && (
          <>
            {messageList.length > 0 && (
              <div
                id="scrollableDiv"
                className="scroller scroll-div"
                ref={scrollContainerRef}
                style={{ height: `calc(100% - ${extraHeight}px)` }}
              >
                <InfiniteScroll
                  dataLength={messageList.length}
                  next={() => {
                    loadMoreMessages();
                  }}
                  style={{
                    overflow: "none",
                  }}
                  className="infinite-scroll mb-2"
                  inverse={true}
                  hasMore={messageCount > messageList.length}
                  loader={<CircularProgress className="circular-progress" />}
                  scrollableTarget="scrollableDiv"
                >
                  <div
                    id="last-empty-message"
                    className="h-100"
                    ref={eleRef}
                  ></div>
                  {[...messageList].map((message, index) => {
                    return (
                      <React.Fragment key={index}>
                        <ChatSeenAvatar
                          // handleAddNewChat={handleAddNewChat}
                          index={index}
                        />
                        <div
                          key={index}
                          id={message._id}
                          className="position-relative"
                          onDoubleClick={handleDoubleClick(message)}
                          onMouseEnter={() => {
                            setIsReplyIconVisible(true);
                            setHoveredMessageId(message._id);
                          }}
                          onMouseLeave={() => {
                            setIsReplyIconVisible(false);
                          }}
                        >
                          <MessageItem
                            hoveredMessageId={hoveredMessageId}
                            isReplyIconVisible={isReplyIconVisible}
                            setRepliedMessage={setRepliedMessage}
                            repliedMessage={repliedMessage}
                            setReplyMessage={setReplyMessage}
                            loadMoreMessages={loadMoreMessages}
                            isDateSame={checkDateSame(
                              messageList[index],
                              messageList[index + 1]
                            )}
                            key={
                              message.temp_id ? message.temp_id : message._id
                            }
                            message={message}
                            setIsEditingMessage={setIsEditingMessage}
                            setNewMessageText={setNewMessageText}
                            setTargetEditMessage={setTargetEditMessage}
                            nextMessage={
                              index !== messageList.length - 1
                                ? messageList[index + 1]
                                : null
                            }
                            textareaRef={textareaRef}
                            selectedMessage={selectedMessage}
                            setSelectedMessage={setSelectedMessage}
                          />
                        </div>
                        {!checkDateSame(
                          messageList[index],
                          messageList[index + 1]
                        ) && (
                          <div
                            className="divider-pad mt-2"
                            style={{
                              zIndex: `${messageList.length + 5 - index}`,
                              marginTop:
                                messageList.length - 1 === index
                                  ? "30px"
                                  : "0px",
                            }}
                          >
                            <Divider className="divider-content">
                              {formatMessageDate(message.createdAt)}
                            </Divider>
                          </div>
                        )}
                        {currentChat?.unread_count > 0 &&
                          index + 1 == currentChat?.unread_count && (
                            <div
                              className="divider-pad mt-2"
                              style={{
                                zIndex: `${messageList.length + 50}`,
                                color: "red",
                              }}
                            >
                              <Divider className="divider-content">
                                {currentChat?.unread_count} unread messages
                              </Divider>
                            </div>
                          )}
                      </React.Fragment>
                    );
                  })}
                </InfiniteScroll>
              </div>
            )}
            {messageList.length == 0 && (
              <div className="h-100 d-flex justify-content-center align-items-center">
                <Typography>No messages yet!</Typography>
              </div>
            )}
            <div
              className={`chat-bottom-container 
              ${replyMessage ? "chat-bottom-container-margin" : ""}
              ${chatFile ? "chat-bottom-container-file" : ""}
              ${replyMessage && chatFile ? "chat-bottom-container-both" : ""}`}
              style={{ height: `${65 + extraHeight}px` }}
            >
              <div className="chat-bottom-bar">
                {isShowEmojis && (
                  <ChatEmojisPicker
                    setNewMessageText={setNewMessageText}
                    setIsShowEmojis={setIsShowEmojis}
                  />
                )}
                <div className="message-editor">
                  <div className="d-flex align-items-center justify-content-between">
                    {!isShowRecordingElement && (
                      <div className="pe-0 d-flex justify-content-start">
                        <div className="image-icon-parent pe-0 d-flex align-items-end">
                          <label htmlFor="chat-button-file" className="m-0">
                            <input
                              className="d-none"
                              accept="image/png,image/jpg,image/jpeg"
                              id="chat-button-file"
                              type="file"
                              onChange={(e) => setChatFile(e.target.files[0])}
                            />
                            <Tooltip arrow title="Send Image">
                              <IconButton
                                aria-label="upload picture"
                                component="span"
                                className="icon-button-upload textarea-btn me-2"
                              >
                                <PhotoSizeSelectActualIcon className="voice-icon" />
                              </IconButton>
                            </Tooltip>
                          </label>
                        </div>
                        <div className="image-icon-parent pe-0 d-flex align-items-end">
                          <Tooltip
                            arrow
                            title={isShowEmojis ? "Hide Emojis" : "Show Emojis"}
                          >
                            <IconButton
                              aria-label="send Emojis"
                              component="span"
                              className="icon-button-upload textarea-btn me-2"
                              onClick={() => {
                                setIsShowEmojis(!isShowEmojis);
                              }}
                            >
                              <SentimentSatisfiedAltIcon className="voice-icon" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    )}
                    {!isShowRecordingElement && (
                      <div className="text-area-parent">
                        <div className="textarea-container">
                          {chatFile && (
                            <div
                              className="image-div"
                              style={{
                                bottom:
                                  !isEditingMessage && replyMessage
                                    ? "calc(100% + 63px)"
                                    : "100%",
                              }}
                            >
                              <ImageSelector
                                file={chatFile}
                                setFile={setChatFile}
                              />
                            </div>
                          )}
                          <textarea
                            ref={textareaRef}
                            value={newMessageText}
                            autoFocus={true}
                            onPaste={handlePaste}
                            onDrop={handleDrop}
                            onChange={handleAreaChange}
                            onKeyDown={handleAreaKeyDown}
                            onKeyUp={handleAreaKeyUp}
                            className="send-message-area"
                            style={{
                              borderTopLeftRadius:
                                chatFile || replyMessage ? "0" : "10px",
                              borderTopRightRadius:
                                chatFile || replyMessage ? "0" : "10px",
                            }}
                            placeholder="Message..."
                          />
                          {!isEditingMessage && replyMessage && (
                            <ReplyMessageContainer
                              replyMessage={memoizedReplyMessage}
                              setReplyMessage={setReplyMessage}
                            />
                          )}
                        </div>
                      </div>
                    )}
                    <div
                      className="d-flex justify-content-evenly align-items-center ps-0"
                      style={{ width: isShowRecordingElement ? "100%" : "" }}
                    >
                      {!isEditingMessage && isShowRecordingElement && (
                        <div style={{ position: "relative", width: "100%" }}>
                          <VoiceRecorder
                            className="recording-container"
                            onStop={onStopRecording}
                            hidden={false}
                            isStartRecording={isRecording}
                            isBorderRadius={replyMessage}
                          />
                          {replyMessage && (
                            <ReplyMessageContainer
                              replyMessage={replyMessage}
                              setReplyMessage={setReplyMessage}
                            />
                          )}
                        </div>
                      )}
                      {!isEditingMessage &&
                        (isShowRecordingElement ? (
                          <Tooltip arrow title="Cancel Recording">
                            <IconButton
                              className="textarea-btn mx-2"
                              color="secondary"
                              onClick={() => {
                                setIsRecording(false);
                                setIsDiscardRecording(true);
                              }}
                            >
                              <CancelIcon
                                className="voice-icon"
                                color="error"
                              />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip arrow title="Start Recording">
                            <IconButton
                              className="textarea-btn mx-2"
                              onClick={(e) => {
                                setIsRecording(true);
                                setIsShowRecordingElement(true);
                              }}
                            >
                              <KeyboardVoiceIcon className="voice-icon" />
                            </IconButton>
                          </Tooltip>
                        ))}
                      {isShowRecordingElement && (
                        <Tooltip arrow title="Send Recording">
                          <IconButton
                            className="textarea-btn"
                            onClick={(e) => {
                              setIsRecording(false);
                            }}
                          >
                            <SendIcon className="voice-icon" />
                          </IconButton>
                        </Tooltip>
                      )}
                      {!isShowRecordingElement &&
                        (isEditingMessage ? (
                          <div className="d-flex">
                            <Tooltip arrow title="Cancel Edit">
                              <IconButton
                                className="textarea-btn mx-2"
                                color="secondary"
                                onClick={() => {
                                  setNewMessageText("");
                                  setChatFile(null);
                                  setIsEditingMessage(false);
                                }}
                              >
                                <CancelIcon
                                  className="voice-icon"
                                  color="error"
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip arrow title="Send Message">
                              <div>
                                <IconButton
                                  className="textarea-btn"
                                  disabled={
                                    isSendingMessage ||
                                    (newMessageText === "" && !chatFile)
                                  }
                                  onClick={(e) => {
                                    !isEditingMessage
                                      ? handleSendMessage(e)
                                      : handleSendEditMessage(e);
                                  }}
                                >
                                  <SendIcon className="voice-icon" />
                                </IconButton>
                              </div>
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="send-icon-parent">
                            {isSendingMessage ? (
                              <IconButton className="textarea-btn">
                                <CircularProgress
                                  style={{ width: 22, height: 22 }}
                                />
                              </IconButton>
                            ) : (
                              <Tooltip arrow title="Send Message">
                                <div>
                                  <IconButton
                                    className="textarea-btn"
                                    disabled={
                                      isSendingMessage ||
                                      (newMessageText === "" && !chatFile)
                                    }
                                    onClick={(e) => {
                                      !isEditingMessage
                                        ? handleSendMessage(e)
                                        : handleSendEditMessage(e);
                                    }}
                                  >
                                    <SendIcon className="voice-icon" />
                                  </IconButton>
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {loadingMessageList && (
          <div className="h-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </div>
        )}
      </div>
    </div>
  );
}

export default MessageContainer;
